import { render, staticRenderFns } from "./chapters.vue?vue&type=template&id=22c5d1a7&"
import script from "./chapters.vue?vue&type=script&lang=ts&"
export * from "./chapters.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Buildserver\\Agent01\\_work\\1030\\s\\JCD.Retail.Webshop\\App\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22c5d1a7')) {
      api.createRecord('22c5d1a7', component.options)
    } else {
      api.reload('22c5d1a7', component.options)
    }
    module.hot.accept("./chapters.vue?vue&type=template&id=22c5d1a7&", function () {
      api.rerender('22c5d1a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/education/material/chapters.vue"
export default component.exports